import { computed } from "@preact/signals-react"
import { offices, providers, reports, searchID, sites } from "@signals"

export const ratingPayload = computed(() => ({
	reportExecutionID: reports.value,
	officePickupID: offices.value,
	siteID: sites.value,
	providerID: providers.value,
	searchID: searchID.value,
	reportType: 'rating',
	getDiffPriceChar: true,
	isNewVersion: true,
}))